"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var kendo_react_common_1 = require("@progress/kendo-react-common");
/**
 * Represents the KendoReact ToolbarSpacer component.
 * To specify an empty space, provide a ToolbarSpacer component
 * ([see example]({% slug content_toolbar %})).
 */
exports.ToolbarSpacer = React.forwardRef(function (props, ref) {
    var element = React.useRef(null);
    var spacer = React.useRef(null);
    React.useImperativeHandle(spacer, function () { return ({ element: element.current }); });
    React.useImperativeHandle(ref, function () { return ({ element: element.current }); });
    var className = React.useMemo(function () { return kendo_react_common_1.classNames('k-spacer', props.className); }, [props.className]);
    return (React.createElement("span", { ref: element, className: className }));
});
exports.ToolbarSpacer.propTypes = {
    className: PropTypes.string
};
//# sourceMappingURL=ToolbarSpacer.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-buttons@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-buttons/dist/npm/toolbar/tools/ToolbarSpacer.js
// module id = 6457
// module chunks = 0